// ADDED: V2 Page Entry Point following Page -> Module pattern
import React from "react";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useMaintenanceSalaryCombinationV2 } from "../../hooks/useMaintenanceSalaryCombinationV2";
import MaintenanceSalaryCombinationV2Module from "../../components/modules/MaintenanceSalaryCombinationV2/MaintenanceSalaryCombinationV2Module";
import { useFilterManager } from "../../hooks/useFilterManager";
import { FEATURES } from "../../../config/features";

const MaintenanceSalaryCombinationV2Page = ({ user, isHideSideMenu }) => {
  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();
  const filterManager = useFilterManager(FEATURES.MAINTENANCE_SALARY_FILTERS);
  const hookMethods = useMaintenanceSalaryCombinationV2({
    showGeneralMessage,
    apiFilterPayload: filterManager.apiFilterPayload,
    additionalFilters: filterManager.additionalApiFilterPayload,
    user: user
  });

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            {/* Passing the hook methods to the Module */}
            <MaintenanceSalaryCombinationV2Module
              user={user}
              filterManager={filterManager}
              showGeneralMessage={showGeneralMessage}
              {...hookMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={showMessage}
        message={message}
        isSuccess={isSuccess}
      />

      <LoadingSpinner loading={hookMethods.loading} />
    </>
  );
};

export default MaintenanceSalaryCombinationV2Page;